/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 13.03.14
 *   Time: 19:11
 */

export class TypeUtil {
    private static IS_ARRAY_VECTOR: RegExp = /__AS3__.vec::Vector.<[\w\.:]+>/;
    private static IS_ARRAY_MEMEBRS: any[] =
    ['length', 'concat', 'push', 'pop', 'shift', 'unshift',
        'indexOf', 'lastIndexOf', 'reverse', 'slice', 'splice'];

    /**
     * Checks whether the argument is an Array like object.
     *
     * @param array An Object instance.
     *
     * @return Returns True if the argument is an Array like object.
     */
    public static isArrayLike(array: any): boolean {
        if (!array) {
            return false;
        }

        if (array instanceof Array) {
            return true;
        }

        // TODO: @HTML5
        /*if (getQualifiedClassName(array).match(TypeUtil.IS_ARRAY_VECTOR)) {
            return true;
        }*/

        for (let i: number = 0, l: number = TypeUtil.IS_ARRAY_MEMEBRS.length; i < l; i++)
            if (!(TypeUtil.IS_ARRAY_MEMEBRS[i] in array)) {
                return false;
            }

        return true;
    }

    public static isSimpleObject(value: any): boolean {
        return value instanceof Object && Object(value).constructor === Object;
    }

    public static isSameType(a: any, b: any): boolean {
        return Object(a).constructor == Object(b).constructor;
    }

    public static isPrimitiveType(value: any): boolean {
        return value == Number || value == Number || value == Number || value == String || value == Boolean;
    }

    public static isPrimitive(value: any): boolean {
        return value == undefined || value == null || value instanceof Number || value instanceof Number || value instanceof Number || value instanceof String || value instanceof Boolean;
    }

    public static isImmutableType(value: any): boolean {
        return value == Number || value == Number || value == Number || value == String || value == Boolean || value == Function || value == Object;
    }

    public static isImmutable(value: any): boolean {
        return value == undefined || value == null || value instanceof Number || value instanceof Number || value instanceof Number || value instanceof String || value instanceof Boolean || value instanceof Function || value instanceof Object;
    }

    public static getSimilarTo(something: any): any {
        if (something && something instanceof Object) {
            try {
                return new (Object(something).constructor);
            }
            catch (error) {
            }
        }
        return something;
    }

    public static clone(value: any): any {
        if (TypeUtil.isImmutable(value)) {
            return value;
        }
        else if ('clone' in value && value.clone instanceof Function) {
            try {
                return value.clone();
            }
            catch (e) {
            }
        }

        if (TypeUtil.isArrayLike(value)) {
            return value.slice();
        }
        // TODO: @HTML5
        /* else if (value instanceof ByteArray) {
             let bytes: ByteArray = new ByteArray();
             let pos: number = value.position;
             value.position = 0;
             value.readBytes(bytes, 0, value.bytesAvailable);
             value.position = pos;
             bytes.position = 0;
             return bytes;
         }*/
        else if (value instanceof Date) {
            let date: Date = new Date();
            date.setTime(value.getTime());
            return date;
        }
        else if (value instanceof Object) {
            let map: Object = TypeUtil.getSimilarTo(value);
            for (let key in value)
                map[key] = TypeUtil.clone(value[key]);
            return map;
        }

        throw new Error("Clonning of " + String(value) + "is not supported.");
    }
}
